export enum FileUploadFlowStateEnum {
    UNSELECTED = 'UNSELECTED',
    SELECTED = 'SELECTED'
}
